import { Logger } from '~~/helpers/logger';
import { CATEGORY_TREE } from '~~/constants/categoryTree';
import { CUSTOM_QUERIES } from '~~/constants/customQueries';
import { findCategoryTreeByKey } from '~~/helpers/category/categoriesTree';

import { EXPONDO_MIDDLEWARE_ROUTES } from '~~/constants/routes';
import type { Category, Query } from '~~/types/commercetools';
import type { CategoryTree } from '~~/types/category/CategoryTree';

export const useCategoryTree = () => {

  const { makeCommercetoolsRequest } = useExpondoMiddleware();
  const categoryTree = useState<CategoryTree>('categoryTree', () => CATEGORY_TREE.DEFAULT);

  const load = async (slug: string, acceptLanguage: string) => {

    try {

      const categoryResponse = await makeCommercetoolsRequest<Query>({
        endpoint: EXPONDO_MIDDLEWARE_ROUTES.CT.GET_CATEGORY,
        data: [
          {
            slug,
            acceptLanguage,
          },
          {
            categories: CUSTOM_QUERIES.CATEGORIES.TREE,
          },
        ],
      });

      const currentCategory: Maybe<Category> = categoryResponse?.data?.categories?.results?.[0];
      const rootCategoryKey: Maybe<string> = currentCategory?.ancestors?.[0]?.key;
      const rootCategoryTree = findCategoryTreeByKey(rootCategoryKey);

      if (rootCategoryTree) {

        categoryTree.value = rootCategoryTree;
      
      }
    
    } catch (err) {

      Logger.error('error.useCategoryTree', String(err));
    
    }
  
  };

  return {
    categoryTree,
    load,
  };

};
